const achievements = [
  {
    key: 'Organizer',
    name: 'Organizer GDG New Delhi',
    duration: 'January, 2020 - Present',
    description:
      'Officially became organizer of GDG New Delhi'
  },
  {
    key: 'Speaker-Community-Connect',
    name: 'Speaker at Community Connect Days',
    duration: 'July, 2019',
    description:
      'Gave a talk on Machine Learning in JS'
  },
  {
    key: 'Judge',
    name: 'Mentor and Judge at Hack GTBIT - 2019',
    duration: 'June, 2019',
    description:
      'Mentored and Judged a hackathon held in GTBIT'
  },
  {
    key: 'Speaker-WDD3',
    name: 'Speaker at Web Developer Days',
    duration: 'January, 2019',
    description:
      'Gave a talk on Machine Learning in JS'
  },
  {
    key: 'MasterClass',
    name: 'Conducted Master Class on Introduction to ReactJs',
    duration: '21th October, 2018',
    description:
      'Conducted a master-class on Introduction to Reactjs organised by GitAll. Taught attendes to create a Midi-Mixer, a collaborative music player where you can create music tunes in collaboration with other people.'
  },
  {
    key: 'IIPC',
    name: 'Chair Person IIPC',
    duration: 'May, 2018 - July 2019',
    description:
      'IIPC is Industry Institute Partnership Cell, it is the e-cell of GTBIT. The main aim of IIPC is to bridge the gap between the industry demands and what college teaches.'
  },
  {
    key: 'HW',
    name: 'Core Team Member Hello World GTBIT',
    duration: 'May, 2017 - July 2019',
    description:
      'Hello World is the programming society of GTBIT. Initiated in 2016 with a moto to tech students the basic concepts of programming languages. Programmming languages includes C, C++, Python, Java. Along with that they also teaches Web Development and Designing as well.'
  },
  {
    key: 'IEEE',
    name: 'Web Head IEEE-GTBIT',
    duration: 'May, 2018 - Oct, 2018',
    description: 'IEEE-GTBIT Execom Web Head. Created Website for IEEE-GTBIT'
  },
  {
    key: 'IITD',
    name: 'Second Posiiton Cyber Security Hackathon',
    duration: 'April, 2018',
    description:
      'Bagged second position in Cyber Security Hackathon, organised by US Embassy in IIT Delhi. Created a platform to automate the work done in digital forensics lab'
  },
  {
    key: 'SIH',
    name: 'Runner-Up, Smart India Hackathon 2017',
    duration: 'March, 2018',
    description:
      'Bagged second position in Smart India Hackathon for DIPP Department. Created a platform for the loan aggregation for the startups. We had 2 platforms, mobile platform and web platform, tech stack includes HTML/CSS with Material design and bootstrap, Android, MongoDB, PHP, Flask and Machine Learning'
  },
  {
    key: 'DSC',
    name: 'Core Team Member, Developer Students Club by Google',
    duration: 'August, 2017 - May, 2018',
    description: `Developer's Students Club is an initiative taken by Google , during this venture I organised various events and seminars in the college.`
  },
  {
    key: 'IEEE2017',
    name: 'Membership Development and Event Management Head at IEEE GTBIT',
    duration: 'May, 2017 - May, 2018',
    description: ''
  },
  {
    key: 'NPC',
    name: 'Fourth Position in NPC India Hackathon',
    duration: 'January, 2017',
    description:
      'Bagged fourth position in NPC India Hackathon. Created a platform to do the waste management, recycle the waste and make secondary products that can be resell on the platform.'
  },
  {
    key: 'BugSwat',
    name: 'Second Position BugSwat',
    duration: 'March 2016',
    description:
      'Bagged second position in BugSwat competition (competition for debugging the code), held in GATES-GTBIT (the annual cultural fest of Guru Tegh Bahadur Institute of Technology).'
  }
];
export default achievements;
